import $ from "jquery";

const $switchers = $(".price_switcher")

const switcher_checkbox = () => {
   if($switchers.length){
        init();
   }
}


const init = () => {
    // CLick sur les labels
    $('.price-switcher-label').on('click', (e) => click_on_label(e))

    // Click sur l'input
    $('.switch input[type="checkbox"]').on('change', (e) => changeInputCheckBox(e))

    // handler sur le changemnt de prix
    $('.pricing-card-bloc').on('price-changed', (e, is_annual_price) => change_price_handler(e, is_annual_price))
}

const change_price_handler = (e, is_annual_price) => {
    const $annualPrice = $(e.currentTarget).find('.price-card .price-item.annual');
    const $monthlyPrice = $(e.currentTarget).find('.price-card .price-item.monthly');

    if(is_annual_price){
        $annualPrice.removeClass("visually-hidden")
        $monthlyPrice.addClass("visually-hidden")
    }else{
        $annualPrice.addClass("visually-hidden")
        $monthlyPrice.removeClass("visually-hidden")
    }
}

const changeInputCheckBox = (e) => {
    const $input = $(e.currentTarget),
        $label_disabled = $input.parent().prev(),
        $label_enabled = $input.parent().next();
    if($input.is(':checked')){
        $label_disabled.removeClass('active');
        $label_enabled.addClass('active');
        $input.trigger("price-changed", [true])
    }else{
        $label_disabled.addClass('active');
        $label_enabled.removeClass('active');
        $input.trigger("price-changed", [false])
    }
}

const click_on_label = (e) => {
    const $label = $(e.currentTarget),
        $input = $(`#${$label.data('target')}`),
        do_checked = $label.data('enabledchecked'),
        $all_label = $label.parent().children('.price-switcher-label');
    if(do_checked && !$input.is(':checked')){
        $all_label.removeClass('active');
        $input.prop('checked', true);
        $label.addClass('active')
    }
    if(!do_checked && $input.is(':checked')){
        $all_label.removeClass('active');
        $input.prop('checked', false);
        $label.addClass('active')
    }
    $input.trigger("price-changed", [do_checked])

}

export {switcher_checkbox}